
      var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTicketPlanes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 190,
  height: 161,
  viewBox: "0 0 190 161",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M161.5 57.456H155m6.5 10H159M34 59.456v-9a7 7 0 0 1 7-7h38M150 43.456h15a7 7 0 0 1 7 7v60a7 7 0 0 1-7 7h-32.037a7 7 0 0 1-6.002-3.398l-.104-.173a1 1 0 0 0-1.714 0l-.104.173a7 7 0 0 1-6.002 3.398H92",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "m67.118 86.334-8.044 2.8-1.21 17.237-5.848 2.245-2.807-15.385-5.728 1.89-1.801 4.045-5.847 2.245.748-8.121-5.986-5.523 5.848-2.244 4.045 1.801 5.848-2.245L37.8 71.584l5.847-2.245 12.433 12 7.863-3.274-.158.044a4.429 4.429 0 1 1 3.175 8.27l.157-.045Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m136.106 32.835-17.855 6.499m21.275 2.898-17.854 6.498m21.274 2.899-17.854 6.498M13.9 74.865a7 7 0 0 1 4.184-8.972l75.887-27.62a3 3 0 0 1 2.294.1 3 3 0 0 0 3.987-1.452 2.999 2.999 0 0 1 1.693-1.55l32.661-11.889a7 7 0 0 1 8.972 4.184l20.521 56.382a6.999 6.999 0 0 1-4.183 8.972l-32.662 11.887a2.995 2.995 0 0 1-2.293-.1 3 3 0 0 0-3.987 1.451 3.006 3.006 0 0 1-1.693 1.552l-75.887 27.62a7 7 0 0 1-8.972-4.184L13.9 74.865Z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M122.584 104.479 98.642 38.701",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeDasharray: "4 10"
})));

      const __svgRaw = "<svg width=\"190\" height=\"161\" viewBox=\"0 0 190 161\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M161.5 57.4563H155M161.5 67.4563H159\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\"/>\r\n<path d=\"M34 59.4563V50.4563C34 46.5903 37.134 43.4563 41 43.4563H79\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\"/>\r\n<path d=\"M150 43.4563H165C168.866 43.4563 172 46.5903 172 50.4563V110.456C172 114.322 168.866 117.456 165 117.456H132.963C130.504 117.456 128.226 116.166 126.961 114.058L126.857 113.885C126.469 113.238 125.531 113.238 125.143 113.885L125.039 114.058C123.774 116.166 121.496 117.456 119.037 117.456H92\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M67.1181 86.3338L59.0736 89.1348L57.8632 106.371L52.016 108.616L49.209 93.2308L43.4811 95.1202L41.6798 99.1661L35.8326 101.411L36.5815 93.2897L30.5954 87.7672L36.4426 85.5226L40.4884 87.324L46.3356 85.0794L37.8007 71.5837L43.6479 69.3391L56.0809 81.3385L63.9439 78.0646L63.7864 78.1093C65.264 77.5403 66.933 77.8033 68.1639 78.7994C69.3948 79.7954 70.0003 81.3728 69.752 82.9366C69.5037 84.5004 68.4395 85.8127 66.9606 86.3785L67.1181 86.3338Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M136.106 32.8352L118.251 39.3336M139.526 42.2321L121.672 48.7305M142.946 51.629L125.092 58.1274\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\"/>\r\n<path d=\"M13.9006 74.8649C12.5783 71.2321 14.4514 67.2152 18.0843 65.8929L93.9714 38.2723C94.7191 38.0001 95.5442 38.0362 96.2653 38.3724C97.7669 39.0726 99.5519 38.423 100.252 36.9214C100.588 36.2003 101.197 35.6423 101.945 35.3701L134.606 23.4824C138.239 22.1602 142.256 24.0333 143.578 27.6661L164.099 84.0477C165.422 87.6805 163.549 91.6974 159.916 93.0197L127.254 104.907C126.507 105.18 125.682 105.143 124.961 104.807C123.459 104.107 121.674 104.757 120.974 106.258C120.637 106.979 120.029 107.537 119.281 107.81L43.3938 135.43C39.7609 136.752 35.744 134.879 34.4218 131.246L13.9006 74.8649Z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\"/>\r\n<path d=\"M122.584 104.479L98.6422 38.7006\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-dasharray=\"4 10\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/ticketPlanes.5dd41fc5b5ff0aa2eb3ec8a44b837ee4.svg"),
        {
          React: SvgTicketPlanes,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      